import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { Template } from '../models';
import {
  selectTemplatePage,
  selectTemplatePageLoading,
  selectTemplateShowInitWaitingMessage,
} from '../selectors';

export class TemplateDatasource extends BaseDataSource {
  private _templates: Template[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectTemplatePageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectTemplateShowInitWaitingMessage);
    this.store
      .pipe(select(selectTemplatePage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._templates = res.items;
        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get templates() {
    return this._templates;
  }
}
